import styled from 'styled-components';

import { ISpecOfferBenefit } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers/dto/ISpecOffer';

import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';

export const BenefitWrapper = styled.div`
    display: flex;
    flex-wrap: nowrap;
    background: ${COLORS.BgSubstrate};
    border-radius: ${BorderRadius.componentRadius};
    padding: 16px;
`;

export const BenefitImageContainer = styled.div<Pick<ISpecOfferBenefit, 'image' | 'imageLabel'>>`
    width: 68px;
    height: 48px;
    background: ${({ image, imageLabel }) => (!image && imageLabel)
        ? 'transparent'
        : '#F5F5F5'
    };
    
    &,
    & > img {
        border-radius: 12px;
        width: 68px;
        height: 48px;
    }

    & > img {
        object-fit: ${({ image, imageLabel }) => (!image && imageLabel)
            ? 'contain'
            : 'cover'
        };
    }

    @media (max-width: ${breakPoints.sMobile}) {
        &,
        & > img {
            width: 48px;
            height: 34px;
        }
    }
`;

export const BenefitInfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 16px;
`;

export const BenefitInfoTitle = styled.label`
    ${FONTS.MediumS}
`;

export const BenefitInfoDescription = styled.div`
    ${FONTS.MediumS}
    color: ${COLORS.TextHint};
`;
